var _g, _g2, _path, _g3, _g4, _g5, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g6, _g7, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 145,
    viewBox: "0 0 144 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.312 26.1809C118.422 25.2987 117.799 24.4917 116.917 24.3823L100.702 22.3716L101.085 19.294C101.126 18.9384 100.879 18.6169 100.524 18.5759L86.9687 16.8935L87.2355 16.7362C89.0957 15.5598 89.677 13.1115 88.5417 11.2239C87.3996 9.34311 84.9649 8.71392 83.0568 9.81501L81.5043 10.7178C79.5894 11.8257 78.9944 14.1783 79.9039 16.0181L68.6263 14.616L67.0123 15.5462C67.0054 15.553 66.9986 15.553 66.9986 15.5598L66.7661 15.6898C66.6498 15.7855 66.5677 15.9292 66.5472 16.0933C66.4651 16.7567 66.3831 17.4269 66.301 18.0971L51.5081 16.2643C51.1319 16.2164 50.8242 16.2779 50.5027 16.4626L49.0323 17.3106C49.005 17.3312 48.9776 17.3448 48.9502 17.3654C48.5262 17.6047 48.2253 18.0288 48.1569 18.5554C47.7055 22.2074 47.2473 25.8663 46.7959 29.5184H40.586L39.0951 30.6469C39.0951 30.6537 39.0883 30.6537 39.0814 30.6537L38.8694 30.8178C38.7668 30.9273 38.7053 31.0777 38.7053 31.2419C38.7053 31.9121 38.7053 32.5892 38.7053 33.2662H23.7961C23.4199 33.2662 23.119 33.362 22.8249 33.5877L21.4708 34.6135C21.4434 34.6341 21.4229 34.6477 21.3956 34.6682C21.0057 34.9623 20.7595 35.4274 20.7595 35.954C20.7595 66.429 20.7595 96.9176 20.7595 127.393C20.7595 128.282 21.4776 129 22.3599 129C44.3407 129 66.3078 129 88.2818 129C88.6511 129 88.9794 128.877 89.253 128.671L90.6824 127.591C91.079 127.29 91.3115 126.818 91.3115 126.312V117.674C95.4424 118.187 99.5732 118.7 103.704 119.213C104.066 119.261 104.415 119.179 104.709 119.008L106.255 118.112C106.693 117.859 106.98 117.421 107.041 116.922L118.312 26.1809Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.8638 11.5319C85.3479 11.7166 86.4011 13.0639 86.2164 14.548C86.148 15.0951 85.9224 15.5875 85.5804 15.9773C84.4519 16.1893 83.3167 15.6696 82.7353 14.6711C82.1677 13.6794 82.2771 12.4278 83.0294 11.5593C83.2961 11.5046 83.5766 11.4909 83.8638 11.5319Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.0325 27.2891C58.0325 27.8362 57.8684 28.3491 57.5812 28.78C56.4869 29.1288 55.2901 28.7527 54.5925 27.8362C53.9017 26.9198 53.8607 25.6682 54.4967 24.7108C54.7566 24.6218 55.037 24.5808 55.3243 24.5808C56.822 24.5808 58.0325 25.7913 58.0325 27.2891Z",
    fill: "#606060"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M128.805 99.5042H127.621V106.2H128.805V99.5042Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M131.561 102.26H124.865V103.443H131.561V102.26Z",
    fill: "url(#paint1_linear)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M35.0327 16.5381H33.8495V23.2336H35.0327V16.5381Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M37.7888 19.2942H31.0934V20.4774H37.7888V19.2942Z",
    fill: "url(#paint3_linear)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.078 71.1552C123.777 71.1552 125.155 69.7773 125.155 68.0776C125.155 66.3779 123.777 65 122.078 65C120.378 65 119 66.3779 119 68.0776C119 69.7773 120.378 71.1552 122.078 71.1552Z",
    fill: "url(#paint4_linear)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M118.312 26.1812L107.041 116.922C106.98 117.421 106.686 117.866 106.255 118.112L104.702 119.008V119.001C105.12 118.762 105.421 118.331 105.489 117.811L116.76 27.0634C116.869 26.1812 116.247 25.381 115.365 25.2716L100.565 23.4319L100.702 22.3582L116.917 24.3688C117.799 24.4988 118.422 25.299 118.312 26.1812Z",
    fill: "url(#paint5_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.76 27.0772L105.489 117.825C105.427 118.345 105.12 118.769 104.702 119.015C104.408 119.186 104.06 119.268 103.697 119.22C81.8941 116.512 60.0911 113.804 38.2813 111.095C37.399 110.986 36.7767 110.186 36.8861 109.304C40.6476 79.0543 44.4023 48.805 48.1569 18.5557C48.2185 18.0359 48.5262 17.6051 48.9502 17.3657C48.9776 17.3452 49.005 17.3315 49.0323 17.3178C49.3059 17.1879 49.6205 17.1263 49.9488 17.1674L66.1642 19.1781C66.0274 20.2792 65.8907 21.3734 65.7539 22.4745L52.828 20.8673C51.9458 20.7579 51.1456 21.3803 51.0362 22.2625L40.5929 106.417C40.4835 107.3 41.1058 108.1 41.9881 108.209L100.818 115.513C101.7 115.623 102.5 115.001 102.61 114.118L113.06 29.9633C113.169 29.0811 112.547 28.2809 111.665 28.1715L100.161 26.7421L100.572 23.4457L115.371 25.2854C116.247 25.3948 116.869 26.195 116.76 27.0772Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.06 29.9632L102.61 114.118C102.5 115 101.7 115.623 100.818 115.513L41.9881 108.209C41.1058 108.1 40.4835 107.3 40.5929 106.417L51.043 22.2624C51.1524 21.3801 51.9526 20.7578 52.8348 20.8672L65.7607 22.4676C65.7128 22.8437 65.6718 23.213 65.6239 23.5823C65.5829 23.938 65.8359 24.2594 66.1847 24.3004C76.758 25.6135 87.3244 26.9266 97.8907 28.2397C98.0344 28.2603 98.178 28.2261 98.2943 28.1577L99.8467 27.2618C100.045 27.1455 100.134 27.0156 100.161 26.783L100.168 26.7488L111.672 28.1782C112.54 28.2808 113.169 29.081 113.06 29.9632Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M100.154 26.7421L100.148 26.7763C100.12 27.0088 100.031 27.1388 99.8331 27.255L98.2806 28.1509C98.4447 28.0552 98.5678 27.8842 98.5952 27.6722L99.5253 20.1834C99.5663 19.8278 99.3201 19.5132 98.9645 19.4653L85.4094 17.7829C85.4983 17.735 85.5872 17.6871 85.6761 17.6324L86.9619 16.887L100.517 18.5694C100.873 18.6104 101.119 18.9318 101.078 19.2875L100.695 22.3651L100.558 23.4388L100.154 26.7421Z",
    fill: "url(#paint6_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.904 16.0183C78.9944 14.1786 79.5894 11.8328 81.5043 10.718C83.4124 9.61008 85.8472 10.2393 86.9893 12.1269C88.1314 14.0145 87.5501 16.4628 85.683 17.6392C85.5941 17.6939 85.512 17.7418 85.4163 17.7896L98.9714 19.472C99.327 19.5131 99.5732 19.8345 99.5322 20.1901L98.6021 27.6789C98.5747 27.891 98.4516 28.0619 98.2874 28.1577C98.1712 28.2261 98.0276 28.2534 97.8839 28.2397C87.3176 26.9266 76.7512 25.6135 66.1779 24.3004C65.8292 24.2594 65.5761 23.938 65.6171 23.5823C65.665 23.213 65.706 22.8437 65.7539 22.4676C65.8907 21.3733 66.0275 20.2722 66.1643 19.1711C66.2121 18.8155 66.2532 18.453 66.3011 18.0974C66.3831 17.4272 66.4652 16.7569 66.5473 16.0867C66.5678 15.9226 66.6498 15.7858 66.7661 15.6832L66.9986 15.5532C67.0055 15.5464 67.0123 15.5464 67.0192 15.5464C67.1012 15.5259 67.1901 15.5191 67.2722 15.5327C71.7928 16.0935 76.3135 16.6543 80.8273 17.2151C80.4238 16.8664 80.1228 16.456 79.904 16.0183ZM97.4394 26.188C97.6377 24.5808 97.8361 22.9668 98.0412 21.3528C98.0823 20.9972 97.8361 20.6826 97.4873 20.6347C87.8031 19.431 78.119 18.2273 68.428 17.0237C68.0724 16.9826 67.7578 17.2288 67.7099 17.5845C67.5116 19.1985 67.3064 20.8125 67.1081 22.4197C67.067 22.7753 67.3132 23.0899 67.6689 23.1378C77.353 24.3415 87.0372 25.5451 96.7281 26.7488C97.0769 26.7899 97.3915 26.5368 97.4394 26.188ZM85.5804 15.9773C85.9155 15.5874 86.1481 15.095 86.2096 14.5547C86.3943 13.0707 85.3411 11.7165 83.857 11.5319C83.5697 11.4977 83.2962 11.5045 83.0226 11.5592C81.901 11.7644 80.9914 12.6808 80.8409 13.8845C80.6563 15.3686 81.7095 16.7159 83.1936 16.9005C84.1305 17.0168 85.0128 16.6407 85.5804 15.9773Z",
    fill: "url(#paint7_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0412 21.3529C97.8429 22.9669 97.6377 24.5809 97.4394 26.1881C97.3984 26.5438 97.0769 26.79 96.7281 26.7489C87.044 25.5453 77.3598 24.3416 67.6688 23.1379C67.3132 23.0969 67.067 22.7754 67.108 22.4198C67.3064 20.8126 67.5047 19.1986 67.7099 17.5846C67.7509 17.2289 68.0724 16.9827 68.428 17.0238C78.1121 18.2274 87.7963 19.4311 97.4873 20.6348C97.8361 20.6758 98.0823 20.9973 98.0412 21.3529Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M88.5417 11.2309C89.6838 13.1185 89.1025 15.5669 87.2354 16.7432L86.9687 16.9005L85.683 17.646C87.55 16.4697 88.1314 14.0213 86.9892 12.1337C85.8539 10.2461 83.4192 9.61692 81.5043 10.7248L83.0568 9.82893C84.9649 8.721 87.3996 9.34335 88.5417 11.2309Z",
    fill: "url(#paint8_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M85.5804 15.9774C85.0127 16.6408 84.1305 17.0169 83.1936 16.9007C81.7095 16.716 80.6631 15.3687 80.8409 13.8846C80.9914 12.6809 81.901 11.7713 83.0226 11.5593C82.2703 12.4279 82.1609 13.6794 82.7353 14.6711C83.3167 15.6696 84.4519 16.1894 85.5804 15.9774Z",
    fill: "url(#paint9_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M80.8204 17.2151C76.3066 16.6543 71.786 16.0935 67.2653 15.5327C67.1833 15.519 67.0944 15.5258 67.0123 15.5463L68.6263 14.6094L79.904 16.0114C80.1228 16.4559 80.4237 16.8663 80.8204 17.2151Z",
    fill: "url(#paint10_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M66.301 18.1043C66.2531 18.4599 66.2121 18.8224 66.1642 19.178L49.9487 17.1605C49.6136 17.1195 49.3059 17.181 49.0323 17.311L50.5027 16.4629C50.8241 16.2783 51.1319 16.2167 51.508 16.2646L66.301 18.1043Z",
    fill: "url(#paint11_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M99.197 57.5179C99.0671 58.5643 98.9372 59.6175 98.8072 60.6776C98.7525 61.1153 98.349 61.4299 97.9113 61.3752C84.6229 59.7269 71.3346 58.0787 58.0531 56.4237C57.6086 56.3689 57.3008 55.9654 57.3555 55.5277C57.4854 54.4745 57.6154 53.4213 57.7453 52.3681C57.8 51.9235 58.1967 51.6089 58.6413 51.6637C71.9296 53.3119 85.218 54.9601 98.4995 56.6151C98.9372 56.6699 99.2518 57.0734 99.197 57.5179Z",
    fill: "url(#paint12_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M100.394 47.9089C100.264 48.9621 100.134 50.0085 100.004 51.0685C99.9493 51.5131 99.5458 51.8208 99.1081 51.7661C85.8198 50.1179 72.5314 48.4697 59.2499 46.8146C58.8054 46.7599 58.4976 46.3633 58.5523 45.9187C58.6823 44.8655 58.8122 43.8191 58.9422 42.7591C58.9969 42.3145 59.3935 42.0068 59.8381 42.0615C73.1264 43.7097 86.4148 45.3579 99.6963 47.013C100.134 47.0677 100.449 47.4643 100.394 47.9089Z",
    fill: "url(#paint13_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M101.584 38.2999C101.454 39.3531 101.324 40.4063 101.194 41.4595C101.139 41.9041 100.736 42.2187 100.298 42.164C87.0098 40.5158 73.7214 38.8675 60.4399 37.2125C59.9954 37.1578 59.6876 36.7543 59.7423 36.3097C59.8723 35.2633 60.0022 34.2101 60.1321 33.1501C60.1869 32.7124 60.5835 32.3978 61.0281 32.4525C74.3164 34.1007 87.6048 35.7489 100.886 37.404C101.324 37.4587 101.639 37.8622 101.584 38.2999Z",
    fill: "url(#paint14_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M98.0412 21.3529C97.8429 22.9669 97.6377 24.5809 97.4394 26.1881C97.3984 26.5438 97.0769 26.79 96.7281 26.7489C87.044 25.5453 77.3598 24.3416 67.6688 23.1379C67.3132 23.0969 67.067 22.7754 67.108 22.4198C67.3064 20.8126 67.5047 19.1986 67.7099 17.5846C67.7509 17.2289 68.0724 16.9827 68.428 17.0238C78.1121 18.2274 87.7963 19.4311 97.4873 20.6348C97.8361 20.6758 98.0823 20.9973 98.0412 21.3529Z",
    fill: "url(#paint15_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M116.76 27.0772L105.489 117.825C105.427 118.345 105.12 118.769 104.702 119.015C104.408 119.186 104.06 119.268 103.697 119.22C81.8941 116.512 60.0911 113.804 38.2813 111.095C37.399 110.986 36.7767 110.186 36.8861 109.304C40.6476 79.0543 44.4023 48.805 48.1569 18.5557C48.2185 18.0359 48.5262 17.6051 48.9502 17.3657C48.9776 17.3452 49.005 17.3315 49.0323 17.3178C49.3059 17.1879 49.6205 17.1263 49.9488 17.1674L66.1642 19.1781C66.0274 20.2792 65.8907 21.3734 65.7539 22.4745L52.828 20.8673C51.9458 20.7579 51.1456 21.3803 51.0362 22.2625L40.5929 106.417C40.4835 107.3 41.1058 108.1 41.9881 108.209L100.818 115.513C101.7 115.623 102.5 115.001 102.61 114.118L113.06 29.9633C113.169 29.0811 112.547 28.2809 111.665 28.1715L100.161 26.7421L100.572 23.4457L115.371 25.2854C116.247 25.3948 116.869 26.195 116.76 27.0772Z",
    fill: "url(#paint16_linear)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter5_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7866 82.7541C11.1643 83.0003 10.4599 82.7404 10.1453 82.1454C10.1247 82.1044 10.0974 82.0633 10.0632 82.0223C9.82383 81.7487 9.40665 81.7214 9.13308 81.9676C8.96894 82.1112 8.88688 82.3369 8.91423 82.5558C8.92107 82.6036 8.93475 82.6515 8.95527 82.6994C9.20147 83.3217 8.94159 84.0262 8.34659 84.3408C8.30555 84.3613 8.26452 84.3886 8.22348 84.4228C7.94992 84.6622 7.92256 85.0794 8.16877 85.3529C8.31239 85.5171 8.53808 85.5992 8.75693 85.5718C8.80481 85.565 8.85268 85.5513 8.90055 85.5308C9.52291 85.2846 10.2273 85.5444 10.5419 86.1394C10.5625 86.1805 10.5898 86.2215 10.624 86.2625C10.8634 86.5361 11.2806 86.5635 11.5541 86.3173C11.7183 86.1736 11.8003 85.9479 11.773 85.7291C11.7661 85.6812 11.7525 85.6333 11.7319 85.5855C11.4857 84.9631 11.7456 84.2587 12.3406 83.9441C12.3816 83.9236 12.4227 83.8962 12.4637 83.862C12.7373 83.6227 12.7646 83.2055 12.5184 82.9319C12.3748 82.7678 12.1491 82.6857 11.9303 82.7131C11.8756 82.7199 11.8277 82.7336 11.7866 82.7541Z",
    fill: "url(#paint17_linear)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter6_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.597 7.26427C114.776 6.90864 114.352 5.9922 114.612 5.13731C114.633 5.07576 114.647 5.00737 114.653 4.93898C114.681 4.4534 114.311 4.03622 113.826 4.00202C113.532 3.98151 113.244 4.11829 113.067 4.35082C113.026 4.40553 112.991 4.46024 112.964 4.5218C112.608 5.34249 111.692 5.76651 110.837 5.50662C110.776 5.48611 110.707 5.47243 110.639 5.46559C110.153 5.43823 109.736 5.80754 109.702 6.29312C109.681 6.5872 109.818 6.87444 110.051 7.05226C110.105 7.09329 110.16 7.12749 110.222 7.15484C111.042 7.51048 111.466 8.42691 111.206 9.2818C111.186 9.34335 111.172 9.41174 111.165 9.48013C111.138 9.96571 111.507 10.3829 111.993 10.4171C112.287 10.4376 112.574 10.3008 112.752 10.0683C112.793 10.0136 112.827 9.95887 112.855 9.89732C113.21 9.07663 114.127 8.6526 114.982 8.91249C115.043 8.93301 115.112 8.94668 115.18 8.95352C115.666 8.98088 116.083 8.61157 116.117 8.12599C116.137 7.83191 116.001 7.54467 115.768 7.36685C115.713 7.32582 115.652 7.29162 115.597 7.26427Z",
    fill: "url(#paint18_linear)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3115 34.8735V126.312C91.3115 126.818 91.079 127.29 90.6823 127.591L89.253 128.672V128.665C89.636 128.371 89.8822 127.912 89.8822 127.393V35.9541C89.8822 35.065 89.1641 34.3469 88.275 34.3469H73.3589V33.2664H89.6975C90.6003 33.2664 91.3115 33.9913 91.3115 34.8735Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M89.889 35.9541V127.4C89.889 127.919 89.6428 128.384 89.2598 128.672C88.9863 128.877 88.6511 129 88.2887 129C66.3147 129 44.3475 129 22.3667 129C21.4776 129 20.7595 128.282 20.7595 127.393C20.7595 96.9109 20.7595 66.4291 20.7595 35.9473C20.7595 35.4207 21.0057 34.9624 21.3956 34.6684C21.4229 34.6478 21.4434 34.6342 21.4708 34.6068C21.7238 34.4427 22.0316 34.3401 22.3599 34.3401H38.6985C38.6985 35.448 38.6985 36.556 38.6985 37.657H25.6837C24.7946 37.657 24.0765 38.3751 24.0765 39.2642V124.069C24.0765 124.958 24.7946 125.676 25.6837 125.676H84.9649C85.854 125.676 86.5721 124.958 86.5721 124.069V39.2642C86.5721 38.3751 85.854 37.657 84.9649 37.657H73.3726V34.3401H88.2887C89.1709 34.3469 89.889 35.065 89.889 35.9541Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5652 39.2712V124.076C86.5652 124.965 85.8471 125.683 84.958 125.683H25.6837C24.7946 125.683 24.0765 124.965 24.0765 124.076V39.2712C24.0765 38.3822 24.7946 37.6641 25.6837 37.6641H38.7053C38.7053 38.0402 38.7053 38.4095 38.7053 38.7857C38.7053 39.1413 38.9994 39.4285 39.3482 39.4285C50.0035 39.4285 60.6519 39.4285 71.3004 39.4285C71.444 39.4285 71.5808 39.3807 71.6902 39.2986L73.1196 38.218C73.3042 38.0812 73.3726 37.9376 73.3726 37.7051V37.6709H84.9649C85.8471 37.6709 86.5652 38.389 86.5652 39.2712Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3658 37.671V37.7052C73.3658 37.9377 73.2974 38.0813 73.1128 38.2181L71.6834 39.2987C71.8407 39.1824 71.9364 38.9978 71.9364 38.7858V31.2422C71.9364 30.8866 71.6492 30.5994 71.2936 30.5994H57.6359C57.718 30.5378 57.8 30.4831 57.8821 30.4216L59.0653 29.5256H72.7229C73.0786 29.5256 73.3658 29.8129 73.3658 30.1685V33.2735V34.354V37.671Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9526 29.5255C50.8242 27.8158 51.1251 25.4084 52.8896 24.0679C54.6472 22.7343 57.1435 23.0558 58.5044 24.7929C59.8723 26.5232 59.5919 29.0263 57.8889 30.4215C57.8069 30.483 57.7316 30.5446 57.6427 30.5993H71.3004C71.656 30.5993 71.9433 30.8865 71.9433 31.2421V38.7857C71.9433 38.9977 71.8407 39.1823 71.6902 39.2986C71.5808 39.3807 71.444 39.4285 71.3004 39.4285C60.6519 39.4285 50.0035 39.4285 39.3482 39.4285C38.9994 39.4285 38.7053 39.1413 38.7053 38.7857C38.7053 38.4164 38.7053 38.0402 38.7053 37.6641C38.7053 36.5561 38.7053 35.455 38.7053 34.3471C38.7053 33.9846 38.7053 33.6222 38.7053 33.2665C38.7053 32.5894 38.7053 31.9192 38.7053 31.2421C38.7053 31.078 38.7669 30.9275 38.8694 30.8181L39.0814 30.6608C39.0883 30.654 39.0951 30.654 39.0951 30.6471C39.1772 30.613 39.2593 30.5993 39.3413 30.5993C43.8962 30.5993 48.451 30.5993 52.999 30.5993C52.5681 30.2984 52.2193 29.929 51.9526 29.5255ZM70.6028 37.452C70.6028 35.8312 70.6028 34.2103 70.6028 32.5826C70.6028 32.227 70.3155 31.9397 69.9668 31.9397C60.2074 31.9397 50.448 31.9397 40.6886 31.9397C40.333 31.9397 40.0458 32.227 40.0458 32.5826C40.0458 34.2103 40.0458 35.8312 40.0458 37.452C40.0458 37.8077 40.333 38.0949 40.6886 38.0949C50.448 38.0949 60.2074 38.0949 69.9668 38.0949C70.3155 38.0949 70.6028 37.8077 70.6028 37.452ZM57.5812 28.7869C57.8684 28.3561 58.0326 27.8431 58.0326 27.296C58.0326 25.7982 56.822 24.5877 55.3243 24.5877C55.037 24.5877 54.7635 24.6288 54.5036 24.7177C53.4162 25.0596 52.6228 26.0855 52.6228 27.296C52.6228 28.7869 53.8334 29.9974 55.3243 29.9974C56.2681 29.9974 57.0956 29.5119 57.5812 28.7869Z",
    fill: "url(#paint19_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6028 32.5826C70.6028 34.2103 70.6028 35.8311 70.6028 37.452C70.6028 37.8076 70.3156 38.0949 69.9668 38.0949C60.2074 38.0949 50.448 38.0949 40.6886 38.0949C40.333 38.0949 40.0458 37.8076 40.0458 37.452C40.0458 35.8311 40.0458 34.2103 40.0458 32.5826C40.0458 32.2269 40.333 31.9397 40.6886 31.9397C50.448 31.9397 60.2074 31.9397 69.9668 31.9397C70.3156 31.9397 70.6028 32.2269 70.6028 32.5826Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.927 23.7054C61.2948 25.4357 61.0144 27.9388 59.3115 29.334L59.0653 29.5186L57.8821 30.4145C59.5851 29.0194 59.8655 26.5163 58.4976 24.786C57.1367 23.0557 54.6404 22.7274 52.8828 24.061L54.3121 22.9804C56.0698 21.6537 58.566 21.9751 59.927 23.7054Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5812 28.7868C57.0956 29.5117 56.2681 29.9973 55.3243 29.9973C53.8334 29.9973 52.6229 28.7868 52.6229 27.2959C52.6229 26.0853 53.4162 25.0663 54.5036 24.7175C53.8676 25.675 53.9086 26.9266 54.5994 27.843C55.2901 28.7594 56.4869 29.1356 57.5812 28.7868Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0058 30.5991C48.451 30.5991 43.903 30.5991 39.3482 30.5991C39.2661 30.5991 39.1772 30.6128 39.102 30.647L40.5861 29.5186H51.9526C52.2193 29.9289 52.5681 30.2982 53.0058 30.5991Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M38.7053 33.2664C38.7053 33.6288 38.7053 33.9913 38.7053 34.3469H22.3599C22.0248 34.3469 21.7239 34.4495 21.4708 34.6137L22.825 33.5878C23.119 33.3621 23.42 33.2664 23.7961 33.2664H38.7053Z",
    fill: "url(#paint20_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M76.2108 68.3304C76.2108 69.3905 76.2108 70.4506 76.2108 71.5106C76.2108 71.9483 75.8484 72.3108 75.4107 72.3108C62.0197 72.3108 48.6357 72.3108 35.2447 72.3108C34.8002 72.3108 34.4445 71.9483 34.4445 71.5106C34.4445 70.4506 34.4445 69.3837 34.4445 68.3304C34.4445 67.8859 34.8002 67.5234 35.2447 67.5234C48.6357 67.5234 62.0197 67.5234 75.4107 67.5234C75.8484 67.5234 76.2108 67.8859 76.2108 68.3304Z",
    fill: "url(#paint21_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M76.2108 58.6464C76.2108 59.7064 76.2108 60.7665 76.2108 61.8265C76.2108 62.2711 75.8484 62.6267 75.4107 62.6267C62.0197 62.6267 48.6357 62.6267 35.2447 62.6267C34.8002 62.6267 34.4445 62.2711 34.4445 61.8265C34.4445 60.7665 34.4445 59.7064 34.4445 58.6464C34.4445 58.2018 34.8002 57.8462 35.2447 57.8462C48.6357 57.8462 62.0197 57.8462 75.4107 57.8462C75.8484 57.8462 76.2108 58.2018 76.2108 58.6464Z",
    fill: "url(#paint22_linear)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M76.2108 48.962C76.2108 50.0221 76.2108 51.089 76.2108 52.1422C76.2108 52.5868 75.8484 52.9492 75.4107 52.9492C62.0197 52.9492 48.6357 52.9492 35.2447 52.9492C34.8002 52.9492 34.4445 52.5868 34.4445 52.1422C34.4445 51.0822 34.4445 50.0221 34.4445 48.962C34.4445 48.5243 34.8002 48.1619 35.2447 48.1619C48.6357 48.1619 62.0197 48.1619 75.4107 48.1619C75.8484 48.1619 76.2108 48.5243 76.2108 48.962Z",
    fill: "url(#paint23_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M70.6028 32.5826C70.6028 34.2103 70.6028 35.8311 70.6028 37.452C70.6028 37.8076 70.3156 38.0949 69.9668 38.0949C60.2074 38.0949 50.448 38.0949 40.6886 38.0949C40.333 38.0949 40.0458 37.8076 40.0458 37.452C40.0458 35.8311 40.0458 34.2103 40.0458 32.5826C40.0458 32.2269 40.333 31.9397 40.6886 31.9397C50.448 31.9397 60.2074 31.9397 69.9668 31.9397C70.3156 31.9397 70.6028 32.2269 70.6028 32.5826Z",
    fill: "url(#paint24_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M89.889 35.9541V127.4C89.889 127.919 89.6428 128.384 89.2598 128.672C88.9863 128.877 88.6511 129 88.2887 129C66.3147 129 44.3475 129 22.3667 129C21.4776 129 20.7595 128.282 20.7595 127.393C20.7595 96.9109 20.7595 66.4291 20.7595 35.9473C20.7595 35.4207 21.0057 34.9624 21.3956 34.6684C21.4229 34.6478 21.4434 34.6342 21.4708 34.6068C21.7238 34.4427 22.0316 34.3401 22.3599 34.3401H38.6985C38.6985 35.448 38.6985 36.556 38.6985 37.657H25.6837C24.7946 37.657 24.0765 38.3751 24.0765 39.2642V124.069C24.0765 124.958 24.7946 125.676 25.6837 125.676H84.9649C85.854 125.676 86.5721 124.958 86.5721 124.069V39.2642C86.5721 38.3751 85.854 37.657 84.9649 37.657H73.3726V34.3401H88.2887C89.1709 34.3469 89.889 35.065 89.889 35.9541Z",
    fill: "url(#paint25_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M91.3115 34.8735V126.312C91.3115 126.818 91.079 127.29 90.6823 127.591L89.253 128.672V128.665C89.636 128.371 89.8822 127.912 89.8822 127.393V35.9541C89.8822 35.065 89.1641 34.3469 88.275 34.3469H73.3589V33.2664H89.6975C90.6003 33.2664 91.3115 33.9913 91.3115 34.8735Z",
    fill: "url(#paint26_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M73.3658 37.671V37.7052C73.3658 37.9377 73.2974 38.0813 73.1128 38.2181L71.6834 39.2987C71.8407 39.1824 71.9364 38.9978 71.9364 38.7858V31.2422C71.9364 30.8866 71.6492 30.5994 71.2936 30.5994H57.6359C57.718 30.5378 57.8 30.4831 57.8821 30.4216L59.0653 29.5256H72.7229C73.0786 29.5256 73.3658 29.8129 73.3658 30.1685V33.2735V34.354V37.671Z",
    fill: "url(#paint27_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M59.927 23.7054C61.2948 25.4357 61.0144 27.9388 59.3115 29.334L59.0653 29.5186L57.8821 30.4145C59.5851 29.0194 59.8655 26.5163 58.4976 24.786C57.1367 23.0557 54.6404 22.7274 52.8828 24.061L54.3121 22.9804C56.0698 21.6537 58.566 21.9751 59.927 23.7054Z",
    fill: "url(#paint28_linear)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M57.5812 28.7868C57.0956 29.5117 56.2681 29.9973 55.3243 29.9973C53.8334 29.9973 52.6229 28.7868 52.6229 27.2959C52.6229 26.0853 53.4162 25.0663 54.5036 24.7175C53.8676 25.675 53.9086 26.9266 54.5994 27.843C55.2901 28.7594 56.4869 29.1356 57.5812 28.7868Z",
    fill: "url(#paint29_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M53.0058 30.5991C48.451 30.5991 43.903 30.5991 39.3482 30.5991C39.2661 30.5991 39.1772 30.6128 39.102 30.647L40.5861 29.5186H51.9526C52.2193 29.9289 52.5681 30.2982 53.0058 30.5991Z",
    fill: "url(#paint30_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 12.7595,
    y: 5.27295,
    width: 117.565,
    height: 139.727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 81.3759,
    y: 9.50806,
    width: 4.86159,
    height: 6.51613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 116.865,
    y: 95.5042,
    width: 26.6955,
    height: 26.6955,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 23.0934,
    y: 12.5381,
    width: 26.6955,
    height: 26.6955,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 111,
    y: 61,
    width: 26.1552,
    height: 26.1552,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d",
    x: 0,
    y: 77.7988,
    width: 24.6872,
    height: 24.6872,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d",
    x: 101.7,
    y: 0,
    width: 26.4191,
    height: 26.4191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.576471 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 127.625,
    y1: 102.851,
    x2: 128.805,
    y2: 102.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 124.868,
    y1: 102.85,
    x2: 131.566,
    y2: 102.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 33.8479,
    y1: 19.8842,
    x2: 35.0285,
    y2: 19.8842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 31.091,
    y1: 19.8826,
    x2: 37.7886,
    y2: 19.8826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 119,
    y1: 68.0806,
    x2: 125.149,
    y2: 68.0806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 94.8289,
    y1: 69.7072,
    x2: 112.638,
    y2: 71.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 84.9536,
    y1: 21.565,
    x2: 100.565,
    y2: 23.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 66.5428,
    y1: 16.1816,
    x2: 99.5259,
    y2: 20.2762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 81.2369,
    y1: 12.92,
    x2: 89.0864,
    y2: 13.8945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 80.8424,
    y1: 13.9421,
    x2: 85.7651,
    y2: 14.5532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 67.0873,
    y1: 14.9851,
    x2: 80.8909,
    y2: 16.6988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 49.1193,
    y1: 16.6401,
    x2: 66.2223,
    y2: 18.7633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 57.5578,
    y1: 53.9405,
    x2: 99.0106,
    y2: 59.0866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 58.7503,
    y1: 44.3348,
    x2: 100.203,
    y2: 49.4809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 59.9427,
    y1: 34.7292,
    x2: 101.396,
    y2: 39.8753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 67.418,
    y1: 19.9955,
    x2: 97.7447,
    y2: 23.7604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 42.5322,
    y1: 63.9241,
    x2: 111.134,
    y2: 72.4405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 8.6524,
    y1: 85.8286,
    x2: 12.0381,
    y2: 82.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 109.702,
    y1: 7.20956,
    x2: 116.118,
    y2: 7.20956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 38.7044,
    y1: 31.3397,
    x2: 71.9401,
    y2: 31.3397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 21.4705,
    y1: 33.9409,
    x2: 38.7044,
    y2: 33.9409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 34.4398,
    y1: 69.9171,
    x2: 76.2101,
    y2: 69.9171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 34.4398,
    y1: 60.238,
    x2: 76.2101,
    y2: 60.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 34.4398,
    y1: 50.5587,
    x2: 76.2101,
    y2: 50.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 40.0428,
    y1: 35.0165,
    x2: 70.6018,
    y2: 35.0165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 20.7588,
    y1: 81.6753,
    x2: 89.8857,
    y2: 81.6753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6CBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A2ABC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8691AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 73.3687,
    y1: 80.9717,
    x2: 91.3143,
    y2: 80.9717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 57.6378,
    y1: 34.4138,
    x2: 73.3687,
    y2: 34.4138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 52.8846,
    y1: 26.2927,
    x2: 60.7942,
    y2: 26.2927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 52.619,
    y1: 27.3554,
    x2: 57.5794,
    y2: 27.3554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 39.0975,
    y1: 30.0852,
    x2: 53.0067,
    y2: 30.0852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5ADC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7B87A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697797"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderOrders);
export default __webpack_public_path__ + "static/media/placeholder_orders.9045802e9d335325b73429e41c5b014b.svg";
export { ForwardRef as ReactComponent };